(function ($) {
  Drupal.behaviors.ehArticleFormatterV1 = {
    attach: function (context, settings) {
      var formatter = $('.eh-article-formatter-v1', context);

      formatter.each(function () {
        var thisFormatter = $(this);
        // The mobile article title (h3) needs to be rearranged under the new The Wink 2.0 menu if it exists
        var $theWink2Menu = thisFormatter.find('.eh-thewink-hp-redesign-menu-formatter-v1'),
          $articleTitle = thisFormatter.find('.article-title'),
          newArticleTitle = $articleTitle.clone(),
          firstDiv = thisFormatter.find('div').first(); // This should be the new The Wink 2.0 menu div

        if ($theWink2Menu.length) {
          $articleTitle.hide();
          newArticleTitle.insertAfter(firstDiv);
        }
      });
    }
  };
})(jQuery);
